import {FC} from 'react'
import {Link} from 'react-router-dom'

/**
 * «خروج» on the registration pages (the user, 2026-10-31): they have no header or side menu, and a person without a
 * business has no panel to go back to, so this is their way out.
 */
export const RegistrationSignOut: FC = () => (
  <Link to='/logout' className='btn btn-light'>
    <i className='las la-sign-out-alt' aria-hidden='true' /> خروج
  </Link>
)
